import { formatSkillLevel } from '../utils/documentFormatters';
export default function SkillLevelLabel({ level }) { return level ? <small className="document-skill-level">{formatSkillLevel(level)}</small> : null; }
